import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetFAQ = async (
                                keyword = '', 
                                page = '', 
                                perPage = '', 
                                // is_paginate = 1, 
                                // status = null
                            ) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['question'] = keyword;
    }

    // if (status) {
    //     params['status'] = status;
    // }
    // params['paginate'] = is_paginate;

    const response = await GET(apiUrl.faq, params);
    return response;
}

export const GetFAQById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.faq + '/' + id,params);
    return response;
}

export const CreateFAQ = async (data) => {
    const response = await POST(apiUrl.faq, data);
    return response;
}

export const UpdateFAQ = async (id, data) => {
    const response = await PUT(apiUrl.faq, id, data);
    return response;
}

export const DeleteFAQ = async (id) => {
    const response = await DELETE(apiUrl.faq, id);
    return response;
}
